import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaAtlassian, FaCog, FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import { jiraSSOConfig } from '../config/msalConfig';
import styles from './HomePage.module.css';
import { useMsal } from "@azure/msal-react";

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { instance } = useMsal();

  // const handleJiraRedirect = () => {
  //   // Redirect to Jira using SSO - the token is already stored and will be reused
  //   window.location.assign(jiraSSOConfig.jiraSSOUrl);
  // };
  

  // const handleJiraRedirect = async () => {
  //   try {
  //     // 1) (Optional) Refresh Azure session so IdP-initiated SSO is seamless
  //     const acct = instance.getAllAccounts()?.[0];
  //     if (acct) {
  //       await instance.acquireTokenSilent({
  //         scopes: ["openid", "profile"],
  //         account: acct
  //       }).catch(() => {/* ignore; top-level SAML will still work */});
  //     }

  //     // 2) Prefer IdP-initiated deep link (User access URL)
  //     const { aadUserAccessUrl, relayStateTarget, fallbackJiraUrl } = jiraSSOConfig;

  //     if (aadUserAccessUrl) {
  //       const url = new URL(aadUserAccessUrl);
  //       if (relayStateTarget) {
  //         // Atlassian + Entra support RelayState for IdP-initiated SSO when configured
  //         url.searchParams.set("RelayState", relayStateTarget);
  //       }
  //       window.location.assign(url.toString()); // top-level nav so SAML cookies can be set
  //       return;
  //     }

  //     // 3) Fallback to SP-initiated (should auto-SSO if SSO is enforced)
  //     window.location.assign(fallbackJiraUrl);
  //   } catch (e) {
  //     console.error("Jira SSO redirect failed:", e);
  //     window.location.assign(jiraSSOConfig.fallbackJiraUrl);
  //   }
  // };

  // HomePage.tsx
// const handleJiraRedirect = async (): Promise<void> => {
//   const { aadUserAccessUrl, relayStateTarget, fallbackJiraUrl } = jiraSSOConfig;

//   try {
//     // 0) Make sure the Entra session is fresh so the SAML hop is truly silent.
//     const acct = instance.getActiveAccount() || instance.getAllAccounts()[0];
    
//     if (acct) {
//       await instance.acquireTokenSilent({
//         scopes: ["openid", "profile", "email"],
//         account: acct,
//         // no forceRefresh: let the presence of a valid SSO cookie do its job
//       }).catch(() => {
//         // Not fatal. The SAML flow will still succeed if the user has an Entra session.
//       });
//     }

//     // 1) Preferred: IdP-initiated deep link (User access URL) to the Atlassian Cloud enterprise app in Entra.
//     // NOTE: For IdP-initiated SSO, RelayState must be configured in Entra’s SAML settings;
//     // passing it as a query param here is typically ignored by Entra.
//     // if (aadUserAccessUrl) {
//     //   console.log('starting aad user access url');
//     //   console.log(aadUserAccessUrl);
//     //   window.location.assign(aadUserAccessUrl); // top-level nav required for SAML cookies
//     //   return;
//     // }

//     // 2) Fallback: SP-initiated login that preserves deep-link with `continue=`.
//     // Atlassian will detect SSO enforcement and bounce to Entra silently if a session exists.
//     console.log('starting fallback');
//     const target = relayStateTarget || fallbackJiraUrl || "https://start.atlassian.com/";
//     const spInitiated = `https://id.atlassian.com/login?application=jira&continue=${encodeURIComponent(target)}`;
//     console.log(spInitiated);
//     window.location.assign(spInitiated);
//   } catch (e) {
//     console.error("Jira SSO redirect failed:", e);
//     // Last-ditch: go straight to your site; Atlassian will still drive SSO if enforced
//     window.location.assign(fallbackJiraUrl || "https://start.atlassian.com/");
//   }
// };

// HomePage.tsx
const handleJiraRedirect = async (): Promise<void> => {
  try {
    // (Optional) refresh CIAM session silently — harmless if it fails
    const acct = instance.getAllAccounts()[0];
    
    if (acct) {
      let loginResponse = await instance.acquireTokenSilent({
        // scopes: ["openid", "profile", "offline_access"],
        scopes: ['openid', 'profile', 'email', 'https://graph.microsoft.com/User.Read'],
        account: acct,
      }).catch(() => {});
      
    }
    
    
    // SP-initiated path (works with Atlassian Access SSO enforcement)
    const target = jiraSSOConfig.relayStateTarget || jiraSSOConfig.fallbackJiraUrl || "https://start.atlassian.com/";
    const spUrl = `https://id.atlassian.com/login?application=jira&continue=${encodeURIComponent(target)}`;
    window.location.assign(spUrl);
  } catch (e) {
    console.error("Jira SSO redirect failed:", e);
    window.location.assign(jiraSSOConfig.fallbackJiraUrl || "https://start.atlassian.com/");
  }
};




  const handleSettingsClick = () => {
    navigate('/settings');
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className={styles.homePage}>
      <div className={styles.background}>
        <div className={styles.overlay}></div>
      </div>
      
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.logoContainer}>
            <h1 className={styles.appName}>Policy.net</h1>
          </div>
          <div className={styles.userInfo}>
            <span className={styles.welcomeText}>Welcome, {user?.name || user?.email}</span>
            <button 
              className={styles.logoutButton}
              onClick={handleLogout}
              title="Sign out"
            >
              <FaSignOutAlt />
            </button>
          </div>
        </div>

        <div className={styles.mainContent}>
          <h2 className={styles.pageTitle}>Choose your destination</h2>
          <p className={styles.pageSubtitle}>Select where you'd like to go next</p>

          <div className={styles.cardsContainer}>
            <div className={styles.card} onClick={handleJiraRedirect}>
              <div className={styles.cardIcon}>
                <FaAtlassian />
              </div>
              <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>Jira</h3>
                <p className={styles.cardDescription}>
                  Access your Jira workspace
                </p>
              </div>
              <div className={styles.cardArrow}>
                →
              </div>
            </div>

            <div className={styles.card} onClick={handleSettingsClick}>
              <div className={styles.cardIcon}>
                <FaCog />
              </div>
              <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>Settings</h3>
                <p className={styles.cardDescription}>
                  Manage your account settings and preferences
                </p>
              </div>
              <div className={styles.cardArrow}>
                →
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
